const AiChatRoleNames = {
  SYSTEM: "system",
  ASSISTANT: "assistant",
  USER: "user"
};

export default AiChatRoleNames;
